<template>
    <div class="w-full mb-4 flex flex-col">
        <label
            class="w-full mb-2 flex font-bold mt-4 page-title"
            :for="id">{{ $__(label) }}</label>
        <div class="flex flex-col w-full">
            <div class="relative flex items-center">
                <input :autocomplete="true"
                       :value="modelValue"
                       @input="$emit('update:modelValue', $event.target.value)"
                       :class="['w-full rounded-md focus:border-l-4', error ? 'border-red-600 border-l-4' : 'border-gray-200']"
                       :type="this.type"
                       :name="name"
                       :id="id"
                />

                <EyeOpen v-if="this.type === 'password'" :class="'login__icon absolute right-0 mr-3.5 cursor-pointer'" @click="toggleType"/>
                <EyeClose v-if="this.type === 'text'" :class="'login__icon absolute right-0 mr-3.5 cursor-pointer'" @click="toggleType"/>
            </div>

            <span v-if="error" class="text-sm font-bold ml-3 mt-2 text-red-600">{{ error }}</span>
        </div>
    </div>
</template>

<script>
import EyeOpen from '@/Components/Icons/EyeOpen';
import EyeClose from '@/Components/Icons/EyeClose';
export default {
    components: { EyeClose, EyeOpen },
    props: [
        'label',
        'id',
        'name',
        'modelValue',
        'error',
    ],
    emits: ['update:modelValue'],
    data: () => ({
        type: 'password'
    }),
    methods: {
        toggleType() {
            this.type = this.type === 'password' ? 'text' : 'password';
        }
    }
}
</script>
